import BaseModel from "./BaseModel";

import { getPointToArray } from "Models";

export class BaseAddressEntryPoint extends BaseModel {
  /* eslint-disable-next-line */
  constructor(props) {
    super(props);
  }

  get entryPointArr() {
    return {
      longitude: getPointToArray(this.entryPoint)[0],
      latitude: getPointToArray(this.entryPoint)[1],
    };
  }

  get entryPointLat() {
    return this.entryPointArr?.latitude;
  }

  get entryPointLng() {
    return this.entryPointArr?.longitude;
  }
}
